import { createContext, useContext } from 'react';
import type { NotificationApi } from './notification';

export const NotificationContext = createContext<NotificationApi | null>(null);

export function useNotification(): NotificationApi {
  const api = useContext(NotificationContext);
  if (!api) {
    throw new Error(
      'useNotification must be used within NotificationProvider',
    );
  }
  return api;
}
